import React from "react";
import Grid from '@material-ui/core/Grid';
import Comma from "../../../assets/images/comma.png";


class IconButton extends React.Component{
    constructor(props) {
        super(props);

    }
    componentDidMount() {
    }

    render() {
        const {backgroundColor,buttonTextColor,text,bottomFontSize,borderColor
            ,icon,iconQuantity,bought
        }=this.props.data
        return(
            <Grid className='button'  container alignItems={"center"} justify={"center"} style={{backgroundColor:backgroundColor,width:'100%'
            ,borderColor:borderColor
            }}>
                <Grid className='button-line'/>
                <img src={Comma} className='button-comma' style={{backgroundColor:'rgba(0.0.0.0.2)'}} alt=""/>
                <Grid  alignItems={"center"} justify={"center"} container className='button-background'/>
                {
                    bought=='1' &&
                    <Grid container style={{position:'absolute'}} alignItems={"center"} justify={"center"}>
                        <p style={{fontSize:bottomFontSize,color:buttonTextColor}}>
                            {text}
                        </p>
                    </Grid>
                }
                {
                    bought=='0' &&
                    <Grid direction={"row-reverse"} container style={{position:'absolute'}} alignItems={"center"} justify={"center"}>
                        <Grid container alignItems={"center"} justify={"center"} sm={4} xs={4}>
                            خرید
                        </Grid>
                        <Grid container style={{position:'relative'}} alignItems={"center"} justify={"center"} sm={2} xs={2}>
                            <img src={icon} style={{width:'100%'}} alt=""/>
                            <p style={{position:'absolute',color:'rgba(0,0,0,0.5)'}}>{iconQuantity}</p>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
export default IconButton